import createElement from 'utils/createElement';
import assign from 'lodash/assign';
import { log } from 'utils/console';

import PostMessage from 'lib/PostMessage';

const ORIGIN = `https://${document.location.host}`;
const NAMESPACE = 'splash-tuning-fork';

const DEFAULT_IFRAME_ATTRS = {
    id: `${NAMESPACE}--iframe`,
    class: `${NAMESPACE}--iframe`,
    height: '0',
    width: '0',
    frameborder: 'none',
    allowtransparency: 'true',
    src: '',
    title: 'Logged In User Menu',
    sandbox: 'allow-scripts allow-same-origin allow-top-navigation-by-user-activation',
};

const POST_MESSAGE_EVENTS = {
    resize: 'pmResize',
    reload: 'pmReload',
};

export default class Iframe {
    // constructor(attrs, params = {}, options = {}) {
    constructor(splashDomain, { iframeAttrs = {}, parent = document.body } = {}) {
        this.splashDomain = splashDomain;
        this.iframeAttrs = assign({}, DEFAULT_IFRAME_ATTRS, iframeAttrs);
        this.mounted = false;
        this.parent = parent;

        this.iframe = createElement('iframe', this.iframeAttrs);

        this.el = createElement('div', { id: `${NAMESPACE}--container` });
        this.el.appendChild(this.iframe);

        this.postMessage = PostMessage.start({
            verify: (origin) => this.verifyPostMessage(origin),
            callback: (msg) => this.handlePostMessage(msg),
        });

        this.log('construct');
        this.log('iframeAttrs', this.iframeAttrs);
        this.log('splashDomain', this.splashDomain);

        this.listeners();
        this.mount();
    }

    log(...args) {
        log('tuning-fork-parent', ...args);
    }

    //
    // Instance Methods
    //

    listeners() {
        this.log('listeners');
        this.postMessage.listen();
        this.iframe.onload = this.onLoad.bind(this);
    }

    mount() {
        if (!this.mounted) {
            this.log('mount', 'to:', this.parent.tagName, this.parent.className);
            this.parent.appendChild(this.el);
            this.mounted = true;
        }
    }

    unmount() {
        this.log('unmount', 'from:', this.parent.tagName, this.parent.className);
        this.el.remove();
        this.mounted = false;
    }

    //
    // PostMessage Handler Methods
    //

    verifyPostMessage(origin) {
        // Logged Out: origin === "event subdomain"
        // or
        // Logged In:  origin === "splash ocb.domain"
        return origin === ORIGIN || origin === this.splashDomain;
    }

    handlePostMessage(msg) {
        if (POST_MESSAGE_EVENTS[msg.event]) {
            this.log('handlePostMessage', msg.event, msg.data);
            this[POST_MESSAGE_EVENTS[msg.event]](msg.data);
        }
    }

    pmResize(data) {
        this.iframe.setAttribute('height', data.height);
        this.iframe.setAttribute('width', data.width);
        this.el.classList.add('rendered');
    }

    pmReload() {
        window.location.reload();
    }

    //
    // Event Handler Methods
    //

    onLoad(e) {
        this.log('loaded');
    }

    //
    // Static Methods
    //

    static create(...args) {
        return new this(...args);
    }
}
